import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import HighchartsReact from 'highcharts-react-official'
import Highcharts from 'highcharts/highstock'
import { fetchWelHistorical } from '@/actions/home'

import NoDataToDisplay from 'highcharts/modules/no-data-to-display'
NoDataToDisplay(Highcharts)

const Container = styled.div`
  width: calc(100% - 40px);
  margin: 0px 20px 30px;

  .highcharts-background {
    fill: transparent;
  }
  .highcharts-area-series {
    path {
      stroke-width: 1px;
    }
  }
  .highcharts-tracker-line {
    stroke: #3cb09b;
    stroke-width: 1px;
  }
  .highcharts-credits {
    display: none;
  }
`
const options = (xAxis, totalTx, min) => {
  return {
    chart: {
      type: 'area',
      height: 79,
      borderRadius: 10,
      margin: 0,
      fillColor: 'transparent',
    },
    title: {
      text: null,
    },
    subtitle: {
      text: null,
    },
    exporting: {
      enabled: false,
    },
    xAxis: {
      visible: false,
      categories: xAxis,
      labels: {
        enabled: false,
      },
      width: '110%',
      left: '-5%',
    },
    yAxis: {
      title: null,
      visible: false,
      labels: {
        enabled: false,
      },
      min: min,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        marker: {
          enabled: false,
        },
        states: {
          hover: {
            enabled: false,
          },
        },
      },
      area: {
        fillColor: {
          linearGradient: {
            x1: 0,
            y1: 0,
            x2: 0,
            y2: 1,
          },
          stops: [
            [0, 'rgba(60, 176, 155, 0.5)'],
            [1, 'rgba(0,0,0,0)'],
          ],
        },
      },
    },
    series: [
      {
        name: 'Price',
        data: totalTx,
        color: '#FFFFFFFF',
      },
    ],
    tooltip: {
      enabled: false,
    },
  }
}

class PriceChart extends React.Component {
  componentDidMount() {
    this.props.fetchWelHistorical()
  }

  render() {
    const chart = this.props.welHistorical
    const { points } = chart
    if (!points) return null

    const xAxis = []
    const totalTx = []
    let min = 0

    Object.keys(points).forEach((key) => {
      xAxis.push(new Date(key))
      const data = points[key].v
      totalTx.push(data[0])
    })
    min = Math.min(...totalTx)

    return (
      <Container>
        <HighchartsReact highcharts={Highcharts} options={options(xAxis, totalTx, min)} />
      </Container>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    welHistorical: state.welHistorical,
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    fetchWelHistorical: () => {
      dispatch(fetchWelHistorical())
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(PriceChart)
